/**
 * Sentry Environment Configuration - Production
 * 
 * This file contains the Sentry configuration for the production environment.
 */

const environment = 'production';

const dsn = 'https://81af3722223d647e38c2c61f73c44257@o4510606227603456.ingest.de.sentry.io/4510730730012752';

// Export for backward compatibility
export default {
  environment,
  dsn,
};

export { environment, dsn };
